import {useMemo, useEffect} from 'react'
import {KTSVG} from '../../../../../../_metronic/helpers'
import {useQueryRequest} from '../../core/QueryRequestProvider'
import {useProductTypesListing, useProductTypesListingState } from '../../../../core/products'

import { filter as filterArray, findIndex, uniq } from 'lodash'

import * as Yup from 'yup'
import {useFormik} from 'formik'

import { useQueryResponseLoading } from '../../core/QueryResponseProvider'

interface ISearchCertificateRequestModel{
  productTypeId: number
  certificate: string
  company: string
  productCategoryString: string
  brand: string
  model: string
}
  

const searchCertificateSchema: any = Yup.object({        
  productTypeId: Yup.number().integer().moreThan(0, 'Select Product Type').required().label('Product Type'),
  certificate: Yup.string().trim().label('Certificate'),        
  company: Yup.string().trim().label('Company'),        
  productCategoryString: Yup.string().trim().label('Product Category'),        
  brand: Yup.string().trim().label('Brand'),        
  model: Yup.string().trim().label('Model'),            
});

const initValues: ISearchCertificateRequestModel = {
  productTypeId: 0,
  certificate: '',
  company: '',
  productCategoryString: '',
  brand: '',
  model: '',
}

const CertificatesListSearchComponent = () => {

  const {updateState} = useQueryRequest()
  const isLoading = useQueryResponseLoading(); 

  
  const product_types = useProductTypesListingState(state => state.productTypes);

  const formik = useFormik({
    initialValues: initValues,
    validationSchema: searchCertificateSchema,
    enableReinitialize: true,
    onSubmit: (values, {setSubmitting}) => {                             
      setSubmitting(true);
      try{
        updateState({filter : values})
      } 
      catch (e) { 
        console.error(e);
      } 
      finally {
        setSubmitting(false);
      }            
    }                    
  })

  const { productTypeId: product_type } = formik.values;
  
  const categories = useMemo(() => {        
    const _idx = findIndex(product_types, { id : parseInt(`${product_type}`)});
    if (! (_idx > -1 && product_types[_idx]?.productCategoriesSet)) {
      return [];
    }

    // return sorted array of unique category names
    return uniq(filterArray(product_types[_idx].productCategoriesSet, (o) => { return !o?.deleted}).map(o => o.name)).sort();

  }, [product_types, product_type]);


  useProductTypesListing();

  // reset productCategoryString after change
  useEffect(() => {
    formik.setFieldValue("productCategoryString", '', false);
  // eslint-disable-next-line
  }, [product_type]);

  
  return (
      <>
  <form id='kt_modal_certificatesearch_form' className='form' onSubmit={formik.handleSubmit} noValidate>
    <div className="d-flex flex-row flex-wrap align-items-end gap-8 mt-6">
      <div className='w-400px d-flex flex-column justify-content-start align-items-stretch gap-3'>    
        <div className="row">
          <div className="col-4">
            <label className='form-label mt-2 fw-bold mb-0 required'>Category</label>        
          </div>
          <div className="col-8">
            <select
              className='form-select form-select-solid form-select-sm'                        
              {...formik.getFieldProps('productTypeId')}                        
              disabled={formik.isSubmitting}
            >
              <option></option>
              { product_types && product_types.length > 0 && 
              product_types.map( o => 
                  <option key={`ptype${o.id ? o.id : 0}`} value={o.id ? o.id : 0}>{o.name}</option>
              )}
            </select>                
            {formik.touched.productTypeId && formik.errors.productTypeId && (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>
                {formik.errors.productTypeId}
              </div>
            </div>         
            )}                                        
          </div>
        </div>
        <div className="row">
          <div className="col-4">
            <label className='form-label mt-2 fw-bold mb-0'>Certificate</label>        
          </div>
          <div className="col-8">
            <input
              type='text'
              className='form-control form-control-sm form-control-solid'                            
              {...formik.getFieldProps('certificate')}
            />
            {(formik.touched.certificate && formik.errors.certificate) && 
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>{formik.errors.certificate}</div>
            </div>                        
            }
          </div>
        </div>
        <div className="row">
          <div className="col-4">
            <label className='form-label mt-2 fw-bold mb-0'>Company</label>        
          </div>
          <div className="col-8">
            <input
              type='text'
              className='form-control form-control-sm form-control-solid'                            
              {...formik.getFieldProps('company')}
            />
            {(formik.touched.company && formik.errors.company) && 
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>{formik.errors.company}</div>
            </div>
            }                        
          </div>
        </div>
        <div className="row">
          <div className="col-4">
            <label className='form-label mt-2 fw-bold mb-0'>Product Category</label>        
          </div>
          <div className="col-8">
            <select
              className='form-select form-select-solid form-select-sm'                        
              {...formik.getFieldProps('productCategoryString')}                                                    
              disabled={formik.isSubmitting}
            >
              <option></option>
              { categories && categories.length > 0 && 
              categories.map( (val, idx) => 
              <option key={`cat${idx}`} value={val}>{val}</option>
              )}                        
            </select>                
            {formik.touched.productCategoryString && formik.errors.productCategoryString && (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>
                {formik.errors.productCategoryString}
              </div>
            </div>         
            )}                                           
          </div>
        </div>
        <div className="row">
          <div className="col-4">
            <label className='form-label mt-2 fw-bold mb-0'>Brand</label>        
          </div>
          <div className="col-8">
            <input  
              type='text'
              className='form-control form-control-sm form-control-solid'                            
              {...formik.getFieldProps('brand')}
            />
            {(formik.touched.brand && formik.errors.brand) && 
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>{formik.errors.brand}</div>
            </div>
            }
          </div>
        </div>
        <div className="row">
          <div className="col-4">
            <label className='form-label mt-2 fw-bold mb-0'>Model</label>        
          </div>
          <div className="col-8">
            <input  
              type='text'
              className='form-control form-control-sm form-control-solid'                            
              {...formik.getFieldProps('model')}
            />
            {(formik.touched.model && formik.errors.model) && 
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>{formik.errors.model}</div>
            </div>
            }
          </div>
        </div>        
      </div>
      <div>
        <button
          type='submit'
          className='btn btn-primary btn-sm'
          data-kt_modal_certificatesearch_form-action='submit'
          disabled={isLoading || !formik.isValid}
        >   
          <KTSVG
            path='/media/icons/duotune/general/gen021.svg'
            className='svg-icon-1'
          />
          <span className='indicator-label'>Search</span>
          {(isLoading) && (
          <span className='indicator-progress'>
            Please wait...{' '}
            <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
          </span>
          )}
        </button>                
      </div>
    </div>
  </form>            
  </>

  )
}

export {CertificatesListSearchComponent}
